import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbCommoditiesMarket = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Trade Commodities with Confidence and Precision</h1>
              <p>
                Diversify your portfolio with gold, oil, and other high-value
                assets, all available through The Pips’ powerful trading
                platform.
              </p>{" "}
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Trading Commodities
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbCommoditiesMarket.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbCommoditiesMarket;
